export default {"src":"/_next/static/media/iconChecklight.689fe79d.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};